import { Users } from 'lucide-react'
import { AnimatedKpiValue } from '@/components/ui/AnimatedKpiValue'
import { KpiSparkline } from '@/components/ui/KpiSparkline'
import type { CaptacaoTabView } from '@/components/Dashboard/captacaoTab.utils'
import { formatDashboardNumber } from '@/utils/crmValuesDisplay'

type Props = {
  view: CaptacaoTabView
  trendSeries: number[]
  valuesVisible?: boolean
}

export function CaptacaoLeadsHeroCard({ view, trendSeries, valuesVisible = false }: Props) {
  const accent = { bg: '#dbeafe', text: '#2563eb', ring: '#93c5fd' }

  return (
    <article className='relative flex h-full min-h-[260px] flex-col overflow-hidden rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] p-5 shadow-sm'>
      <div
        className='pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full opacity-40 blur-2xl'
        style={{ backgroundColor: accent.ring }}
        aria-hidden
      />

      <div className='flex items-start justify-between gap-3'>
        <div>
          <p className='text-sm font-medium text-text-muted'>Leads captados</p>
          <div className='mt-2'>
            {valuesVisible ? (
              <AnimatedKpiValue
                numericValue={view.totalLeads}
                displayValue={formatDashboardNumber(view.totalLeads, true)}
                format='integer'
                className='text-3xl font-bold tabular-nums tracking-tight text-text-primary sm:text-4xl'
              />
            ) : (
              <span className='text-3xl font-bold text-text-primary sm:text-4xl'>••••</span>
            )}
          </div>
          <p className='mt-2 text-sm text-text-muted'>
            Entradas na carteira closer ·{' '}
            {formatDashboardNumber(view.activeLeads, valuesVisible)} ativos na base
          </p>
        </div>
        <span
          className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ring-1'
          style={{
            backgroundColor: accent.bg,
            color: accent.text,
            boxShadow: `inset 0 0 0 1px ${accent.ring}`,
          }}
          aria-hidden
        >
          <Users size={18} />
        </span>
      </div>

      <div className='mt-auto space-y-2 border-t border-[var(--border)] pt-4'>
        <div className='flex items-center justify-between text-sm'>
          <span className='text-text-secondary'>Qualificados</span>
          <span className='font-semibold tabular-nums text-text-primary'>
            {formatDashboardNumber(view.qualifiedLeads, valuesVisible)}
          </span>
        </div>
        <div className='flex items-center justify-between text-sm'>
          <span className='text-text-secondary'>Em nutrição</span>
          <span className='font-semibold tabular-nums text-text-primary'>
            {formatDashboardNumber(view.nurturingLeads, valuesVisible)}
          </span>
        </div>
      </div>

      <div className='mt-4'>
        <KpiSparkline
          data={trendSeries.length > 0 ? trendSeries : [0]}
          strokeColor={accent.text}
          fillColor={accent.ring}
        />
      </div>
    </article>
  )
}
